import { render, staticRenderFns } from "./CookiesMessage.vue?vue&type=template&id=90a6342a&scoped=true&"
import script from "./CookiesMessage.vue?vue&type=script&lang=js&"
export * from "./CookiesMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a6342a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBanner,VBtn})
